<template>
	<SIcon v-if="typeName" class="data-type-icon" :name="`data-type-${typeName}`" :height="size" :width="size" />
	<SIcon v-else class="data-type-icon" :name="`data-type-${dataType}`" :height="size" :width="size" />
</template>

<script>
import { DataTypeEvaluator } from '@ply-io/data-types';

const evaluator = new DataTypeEvaluator();

export default {
	name: 'DataTypeIcon',
	props: {
		size: { type: Number, default: 20 },
		typeName: { type: String },
		itemValue: { type: [String, Number, Array, Object, Boolean] },
	},
	computed: {
		dataType() {
			return evaluator.evaluate(this.itemValue);
		},
	},
};
</script>

<style scoped lang="scss"></style>
